import { Offer } from "@duffel/api/types";

export const offerIsExpired = (offer: Offer) => {
  return offer.expires_at && new Date(offer.expires_at) < new Date();
};
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";